<div *ngIf="isLoaded; else loading" class="cp-onboard-wrapper">
  <div class="modal_title_container" mat-dialog-title>
    <div class="pop_options">
      <ng-container>
        <div
          class="title_box"
          [ngClass]="{active: selectedTab == index}"
          *ngFor="let title of tabList; let index = index"
          (click)="selectTab(index)"
        >
          <div>{{ title }}</div>
        </div>
      </ng-container>
    </div>
    <i class="icon-close" (click)="onClose()"></i>
  </div>

  <div class="graph-inner-container f-1 o-auto" mat-dialog-content>
    <div class="body-container" [ngSwitch]="selectedTab" [formGroup]="clinicGroup">
      <app-clinic-account-info
        *ngSwitchCase="0"
        [isNewOrg]="isNewOrg"
        [organization]="organization"
        [isSubmitted]="isSubmitted"
        (checkPrimaryStoreNumVal)="checkAndReturnStoreVal($event)"
      ></app-clinic-account-info>
    </div>
  </div>

  <footer mat-dialog-actions>
    <div>
      <button
        class="btn btn-act btn-xs bg_main_normal_blue"
        [ngClass]="{inactive: clinicGroup.invalid}"
        (click)="complete()"
        mat-button
        [disabled]="!isEditable || checkPrimaryStoreNumber"
      >
        {{ isNewOrg ? labels.createBtnLabel : labels.saveBtnLabel }}
      </button>
    </div>
  </footer>
</div>

<ng-template #loading>
  <skeleton-loader type="modal-1"></skeleton-loader>
</ng-template>
